import { render } from "./Footer.vue?vue&type=template&id=f5c2bb96"
const script = {}

import exportComponent from "/home/harris/Projects/cspd.com.cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__